import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home';
import { Contact } from './pages/Contact';
import { Navbar } from './components/navbar/Navbar';
import { Footer } from './components/footer/Footer';
import { OurProjects } from './pages/OurProjects';
import { About } from './pages/About';
import { ActiveProjects } from './pages/ActiveProjects';
// import { QueryModal } from './layout/queryModal/QueryModal';
import ScrollToTop from './util/scrollToTop';
import { TermsConditions } from './pages/TermsConditions';
import { PrivacyPolicy } from './pages/PrivacyPolicy';

function App() {
  return (
    <div className="App">
      {/* { !['/terms-of-use', '/privacy-policy'].includes(window.location.pathname) && <QueryModal />} */}
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/about' element={<About />} />
            <Route path='/our-projects' element={<OurProjects />} />
            <Route path='/celeste' element={<ActiveProjects />} />
            <Route path='/terms-of-use' element={<TermsConditions />} />
            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
